export const fr = {
  auth: {
    googleButton: {
      text: 'Continuer avec Google',
      errors: {
        login_failed: 'Impossible de se connecter',
      },
    },
    microsoftButton: {
      text: 'Continuer avec Microsoft',
      errors: {
        login_failed: 'Impossible de se connecter avec Microsoft',
      },
    },
    confirmEmailForm: {
      email: {
        placeholder: 'ex: john@example.com',
        label: 'Email',
      },
      button: "Renvoyer l'email",
      success: 'Email de confirmation envoyé',
      errors: {
        invalid_email: 'Veuillez saisir une adresse email valide',
      },
    },
    confirmEmailPage: {
      titles: {
        confirm: 'Confirmez votre email',
        unsuccessful: 'Confirmation échouée',
        confirmed: 'Email confirmé !',
      },
      messages: {
        check_email:
          'Veuillez vérifier votre email pour le lien de confirmation.',
        cant_find:
          'Vous ne le trouvez pas ? Saisissez votre email ci-dessous pour recevoir un nouveau lien.',
        login_complete:
          'Veuillez vous connecter pour compléter votre inscription.',
      },
      links: {
        return_login: 'Retourner à la connexion',
      },
    },
    confirmEmailSuccessPage: {
      title: 'Succès !',
      message:
        'Veuillez vérifier votre email pour le nouveau lien de confirmation.',
      links: {
        return_login: 'Retourner à la connexion',
      },
    },
    forgotPasswordPage: {
      title: 'Mot de passe oublié ?',
      remember_password: 'Vous vous souvenez de votre mot de passe ?',
      login_link: 'Connexion.',
      form: {
        success_message: 'Email de réinitialisation envoyé',
        error_message: "Impossible d'envoyer l'email de réinitialisation",
      },
    },
    forgotPasswordSuccessPage: {
      title: 'Succès !',
      message:
        'Veuillez vérifier votre email pour le lien de réinitialisation du mot de passe.',
      links: {
        return_login: 'Retourner à la connexion.',
      },
    },
    loginPage: {
      title: 'Connexion',
      no_account: "Vous n'avez pas de compte ?",
      signup_link: "S'inscrire.",
      email_link: 'Se connecter avec email',
      nonprofit_login_link: 'Visiter le portail de connexion OSBL',
    },
    loginWithEmailPage: {
      title: 'Connexion',
      forgot_password: 'Mot de passe oublié ?',
      no_account: "Vous n'avez pas de compte ?",
      signup_link: "S'inscrire.",
      nonprofit_login_link: 'Visiter le portail de connexion OSBL',
      errors: {
        login_failed:
          'Impossible de se connecter. Veuillez vérifier vos identifiants.',
      },
    },
    logoutButton: {
      text: 'Déconnexion',
      errors: {
        microsoft_logout_failed:
          'Impossible de se déconnecter du compte Microsoft',
      },
    },
    resetPasswordPage: {
      title: 'Réinitialiser le mot de passe',
      remember_password: 'Vous vous souvenez de votre mot de passe ?',
      login_link: 'Se connecter.',
      form: {
        success_message: 'Mot de passe réinitialisé avec succès',
        error_message: 'Impossible de réinitialiser le mot de passe',
      },
    },
    resetPasswordSuccessPage: {
      title: 'Succès !',
      message:
        "Votre mot de passe a été réinitialisé avec succès ! Veuillez retourner à l'écran de connexion pour vous connecter",
      links: {
        return_login: 'Retourner à la connexion',
      },
    },
    signupPage: {
      title: "S'inscrire",
      has_account: 'Vous avez déjà un compte ?',
      login_link: 'Se connecter.',
      email_link: "S'inscrire avec email",
      nonprofit_signup_link: "Visiter le portail d'inscription des organismes à but non lucratif",
    },
    signupWithEmailPage: {
      title: "S'inscrire",
      has_account: 'Vous avez déjà un compte ?',
      login_link: 'Se connecter.',
      terms: {
        agree_text: "J'accepte les",
        terms_link: "Conditions d'utilisation",
        and: 'et la',
        privacy_link: 'Politique de confidentialité',
      },
      errors: {
        company_not_exist: "L'entreprise n'existe pas",
      },
    },
    forgotPasswordForm: {
      email: {
        placeholder: 'ex: john@example.com',
        label: 'Email',
      },
      button: 'Envoyer le lien de réinitialisation',
      validation: {
        email_required: 'Veuillez saisir votre adresse email',
        email_invalid: 'Veuillez saisir une adresse email valide',
      },
    },
    signupForm: {
      fields: {
        email: {
          label: 'Email',
          placeholder: 'ex: john@example.com',
        },
        password: {
          label: 'Mot de passe',
          placeholder: '•••••••',
        },
        confirmPassword: {
          label: 'Confirmer le mot de passe',
          placeholder: '•••••••',
        },
      },
      validation: {
        terms_required:
          "Vous devez accepter les conditions d'utilisation et la politique de confidentialité.",
        passwords_match: 'Les mots de passe doivent correspondre.',
        email_required: 'Veuillez saisir votre adresse email',
        email_invalid: 'Veuillez saisir une adresse email valide',
      },
      button: "S'inscrire",
    },
    loginForm: {
      fields: {
        email: {
          label: 'Email',
          placeholder: 'ex: john@example.com',
        },
        password: {
          label: 'Mot de passe',
          placeholder: '•••••••',
        },
      },
      validation: {
        email_required: 'Veuillez saisir votre adresse email',
        email_invalid: 'Veuillez saisir une adresse email valide',
        password_required: 'Veuillez saisir votre mot de passe',
      },
      button: 'Se connecter',
      errors: {
        email_not_confirmed: 'Veuillez confirmer votre email pour continuer',
        login_failed: 'Email ou mot de passe invalide',
      },
    },
    nonprofitLoginPage: {
      title: 'Connexion OSBL',
      no_account: "Vous n'avez pas de compte OSBL ?",
      signup_link: 'En créer un',
      company_login_link: 'Visiter le portail de connexion Entreprise',
    },
    nonprofitSignupPage: {
      title: 'Créer un compte OSBL',
      fields: {
        nonprofit: 'Votre OSBL',
        email: 'Adresse email',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
      },
      cant_find_nonprofit: "Vous ne trouvez pas votre association ?",
      create_new_portal_link: 'En créer une ici',
      next_button: 'Continuer',
      button: 'Créer le compte',
      has_account: 'Vous avez déjà un compte ?',
      login_link: 'Se connecter',
    },
    nonprofitCreatePage: {
      title: 'Ajoutez votre OSBL',
      fields: {
        name: 'Nom de l\'OSBL',
        address: 'Adresse de l\'OSBL',
        logo: 'Logo de l\'OSBL',
        website: 'Site Web',
      },
      button: 'Créer l\'OSBL',
    }
  },
}
